import Svg, { Path } from 'react-native-svg';
import { IconProps } from './types';
import { FC } from 'react';
import { colors } from '../constants';

export const IconPlus: FC<IconProps> = ({
  width = 24,
  height = 24,
  color = colors.gray2,
  ...rest
}) => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...rest}>
      <Path
        d="M11 13v3c0 .283.096.52.287.712.192.192.43.288.713.288s.52-.096.713-.288A.968.968 0 0013 16v-3h3c.283 0 .52-.096.712-.287A.968.968 0 0017 12a.968.968 0 00-.288-.713A.968.968 0 0016 11h-3V8a.967.967 0 00-.287-.713A.968.968 0 0012 7a.968.968 0 00-.713.287A.967.967 0 0011 8v3H8a.967.967 0 00-.713.287A.968.968 0 007 12c0 .283.096.52.287.713.192.191.43.287.713.287h3zm1 9a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 012 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 012.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0112 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 013.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0122 12a9.738 9.738 0 01-.788 3.9 10.098 10.098 0 01-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0112 22zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20z"
        fill={color}
      />
    </Svg>
  );
};
